export enum NotificationChannel {
  EventCodes = 'EventCodes',
  Field = 'Field'
}

export const NotificationChannelMetadata = {
  [NotificationChannel.EventCodes]: {
    id: NotificationChannel.EventCodes,
    description: 'Notifications for event code updates',
    name: 'Event Codes'
  },
  [NotificationChannel.Field]: {
    id: NotificationChannel.Field,
    description: 'Notifications for field updates',
    name: 'Field Updates'
  }
}
